import request from '@/utils/httpRequest'

export default class CustomerService {
    queryById(id) {
        return request({
            url: '/shye/base/shyeCustomerInfo/queryById',
            method: 'get',
            params: {id: id}
        });
    }

    startFlow (params) {
        return request({
            url: '/shye/base/shyeCustomerInfo/startFlow',
            method: 'post',
            data: params
        })
    }
    listAll(params) {
        return request({
            url: '/shye/base/shyeCustomerFollowup/list',
            method: 'get',
            params: params
        });
    }
}
